import moment from 'moment'

export class Utils {
    public static rGbMdColorsArray(slice: number = 5, opacity :string = '1.0'): object {
        let colors: Array<string> = [
            'rgba(216, 27, 96, '+opacity+')',
            'rgba(49, 27, 146, '+opacity+')',
            'rgba(0, 131, 143, '+opacity+')',
            'rgba(255, 143, 0, '+opacity+')',
            'rgba(121, 85, 72, '+opacity+')',
            'rgba(253, 216, 53, '+opacity+')',
            'rgba(104, 159, 56, '+opacity+')',
            'rgba(0, 150, 136, '+opacity+')',
            'rgba(103, 58, 183, '+opacity+')',
            'rgba(244, 67, 54, '+opacity+')',
            'rgba(33, 150, 243, '+opacity+')',
            'rgba(56, 142, 60, '+opacity+')',
            'rgba(255, 241, 118, '+opacity+')',
            'rgba(161, 136, 127, '+opacity+')',
            'rgba(120, 144, 156, '+opacity+')',
            'rgba(244, 81, 30, '+opacity+')',
            'rgba(192, 202, 51, '+opacity+')',
            'rgba(13, 71, 161, '+opacity+')',
            'rgba(158, 158, 158, '+opacity+')',
            'rgba(174, 213, 129, '+opacity+')'
        ];

        if (slice > colors.length || slice < 1) slice = colors.length
        return colors.slice(0,slice);
    }

    public static getProductIconName(type: string): string {
        switch (type) {
            case 'pit': return 'computer';
            case 'pity365': return 'cloud';
            case 'pit_online': return 'tablet_mac';
            case 'pit_online': return 'web';
            default: return 'help';
        }
    }

    /**
     * Return OS icon reference to IMG src
     * @param platform
     */
    public static getOperatingSystemIconUrl(platform: string) {
        switch(platform) {
            case 'Windows': {
                return require('@/assets/img/icons/windows10.svg');
                break;
            }
            case 'Macintosh':
            case 'OS X': {
                return require('@/assets/img/icons/ios.svg');
                break;
            }
            case 'Linux': {
                return require('@/assets/img/icons/linux.svg');
                break;
            }
            case 'Debian': {
                return require('@/assets/img/icons/debian.svg');
                break;
            }
            case 'Ubuntu': {
                return require('@/assets/img/icons/ubuntu.svg');
                break;
            }
            case 'OpenBSD': {
                return require('@/assets/img/icons/freebsd.svg');
                break;
            }
            case 'ChromeOS': {
                return require('@/assets/img/icons/chrome_os.svg');
                break;
            }
            case 'AndroidOS': {
                return require('@/assets/img/icons/android.svg');
                break;
            }
            case 'Windows NT': {
                return require('@/assets/img/icons/windows_xp.svg');
                break;
            }
            default: {
                return require('@/assets/img/icons/unknown.svg')
                break;
            }
        }
    }

    /**
     * Return Web browser icon reference to IMG src
     * @param browserName
     */
    public static getWebBrowserIconUrl(browserName: string) {
        switch(browserName) {
            case 'Chrome': {
                return require('@/assets/img/icons/chrome.svg');
                break;
            }
            case 'Firefox':
            case 'Mozilla':
            case 'Firefox/Mozilla':{
                return require('@/assets/img/icons/firefox.svg');
                break;
            }
            case 'IE': {
                return require('@/assets/img/icons/ie.svg');
                break;
            }

            case 'Edge': {
                return require('@/assets/img/icons/edge.svg');
                break;
            }
            case 'Safari': {
                return require('@/assets/img/icons/safari.svg');
                break;
            }
            case 'Opera': {
                return require('@/assets/img/icons/opera.svg');
                break;
            }
            case 'Netscape': {
                return require('@/assets/img/icons/netscape.svg');
                break;
            }
            default: {
                return require('@/assets/img/icons/unknown.svg')
                break;
            }
        }
    }

    /**
     * Return device MD icon name
     * @param device
     */
    public static getDeviceIconName(device: string): string {
        switch(device) {
            case 'Komputer': {
                return 'desktop_windows';
                break;
            }
            case 'Tablet': {
                return 'tablet_android';
                break;
            }
            case 'Urządzenie mobilne':
            case 'Smartfon': {
                return 'smartphone';
                break;
            }
            case 'Robot': {
                return 'bug_report';
                break;
            }
            default: {
                return 'devices';
                break;
            }
        }
    }

    /**
     * Return StatDeklaracje modul MD icon name
     * @param device
     */
    public static getStatDeklaracjeModulIconName(modul: string): string {

        return (modul == 'EDEKLARACJE') ? 'cloud_done' : 'print';
    }

    /**
     * Function return true if given date is Saturday or Sunday
     *
     * @param date string
     * @return boolean
     */
    public static isWeekend(date: string): boolean {
        return (moment(date).isoWeekday() == 6 || moment(date).isoWeekday() == 7);
    }


    /**
     * Return simple route name
     *
     * @param route string  Route name
     * @return string|undefined
     */
    public static getSimpleRouteName(route: string|undefined): string {
        switch (route) {
            case 'stats-uruchomienia-details-index':
            case 'stats-uruchomienia-product':
            case 'stats-uruchomienia-index':
                return 'uruchomienia';

            case 'stats-pobrania-details-index':
            case 'stats-pobrania-product':
            case 'stats-pobrania-index':
                return 'pobrania';

            case 'stats-deklaracje-details-index':
            case 'stats-deklaracje-product':
            case 'stats-deklaracje-index':
                return 'deklaracje';

            default: return '';
        }
    }
}
